/* eslint-disable */
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useProductStore } from "../store/productStore";
import {
  Box,
  Button,
  Card,
  Chip,
  Container,
  createTheme,
  Divider,
  Grid,
  IconButton,
  List,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import Slider from "react-slick";
import FitbitIcon from "@mui/icons-material/Fitbit";
import HpList from "../components/ProductDetail/HpList";
import Price from "../components/ProductDetail/Price";
import ProductDetailImage from "../components/ProductDetail/ProductDetailImage";
import AdditionalInfo from "../components/ProductDetail/AdditionalInfo";
import ProductSpecs from "../components/ProductDetail/ProductSpecs";
import SimilarProducts from "../components/ProductDetail/SimilarProducts";
import ScrollToTopButton from "../components/ScrollToTopButton";
import BookingModal from "../components/BookingModal";

const ProductDetail = React.forwardRef((props: any, ref: any) => {
  const params = useParams();
  const { products } = useProductStore();
  const id = params?.id as string;
  const product = products.find((p) => p.id === id);
  const [openBooking, setOpenBooking] = useState(false);
  const hpData = product?.hp ? JSON.parse(product.hp.replace(/'/g, '"')) : [];
  //Bỏ những dữ liệu hp không có thông tin sản phẩm
  const filteredHpData = hpData.filter((item: any) =>
    products.some((product) => product.id === item.Href_Hash),
  );

  const images: string[] = React.useMemo(
    () => (product && product.productImage ? product.productImage : []),
    [product],
  );

  const shortDescriptionData = product?.shortDescription
    ? JSON.parse(product?.shortDescription.replace(/'/g, '"'))
    : [];
  // Cắt đôi mảng
  const mid = Math.ceil((shortDescriptionData.length ?? 0) / 2);
  const leftItems = shortDescriptionData.slice(0, mid);
  const rightItems = shortDescriptionData.slice(mid);

  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [htmlContent, setHtmlContent] = useState("");

  const [nav1, setNav1] = useState<Slider | null>(null);
  const [nav2, setNav2] = useState<Slider | null>(null);
  const sliderRef1 = useRef<Slider>(null);
  const sliderRef2 = useRef<Slider>(null);

  const goToSlide = (index: any) => {
    if (sliderRef1.current) {
      sliderRef1.current.slickGoTo(index);
      sliderRef2?.current?.slickGoTo(index);
    }
  };

  // Hàm xử lý HTML string
  const processHtmlContent = (htmlString: string): string => {
    if (!htmlString) return "";

    // Sử dụng DOM parser để xử lý HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");

    // Xử lý tất cả images
    const images = doc.querySelectorAll("img");
    images.forEach((img) => {
      // Xóa tất cả inline styles, width, height
      img.removeAttribute("style");
      img.removeAttribute("width");
      img.removeAttribute("height");

      img.classList.add("w-full", "h-auto", "max-w-full", "block");
      img.style.width = "100%";
      img.style.height = "auto";
      img.style.maxWidth = "100%";
      img.style.display = "block";
      img.style.padding = "15px 0";
    });

    return doc.body.innerHTML;
  };

  useImperativeHandle(ref, () => ({
    goToSlide,
  }));

  const handlePrevImage = React.useCallback(() => {
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    setSelectedImage(images[newIndex]);
  }, [currentImageIndex, images]);

  const handleNextImage = React.useCallback(() => {
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    setSelectedImage(images[newIndex]);
  }, [currentImageIndex, images]);

  const handleCloseModal = () => {
    setSelectedImage(null);
  };
  const handleOpenBooking = () => setOpenBooking(true);
  const handleCloseBooking = () => setOpenBooking(false);

  const renderShortDetail = (text: string, idx: number) => (
    <Box key={idx} className="flex items-start gap-2 mb-2">
      <FitbitIcon className="text-gray-400 mt-1" fontSize="small" />
      <Typography variant="body1" className="text-gray-800">
        {text}
      </Typography>
    </Box>
  );

  useEffect(() => {
    const rawHtml = product?.description ?? "";
    const processedHtml = processHtmlContent(rawHtml);
    setHtmlContent(processedHtml);
    setNav1(sliderRef1.current);
    setNav2(sliderRef2.current);
    if (props.selectedIndex !== undefined && props.selectedIndex >= 0) {
      goToSlide(props.selectedIndex);
    }
  }, [product?.description, props.selectedIndex]);

  useEffect(() => {
    const handleKeyDown = (e: any) => {
      if (!selectedImage) return;
      if (e.key === "ArrowLeft") handlePrevImage();
      if (e.key === "ArrowRight") handleNextImage();
      if (e.key === "Escape") handleCloseModal();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedImage, currentImageIndex, handlePrevImage, handleNextImage]);

  if (!product) {
    return <Typography>Không tồn tại thông tin sản phẩm</Typography>;
  }

  return (
    <Box sx={{ py: 4 }} className="flex flex-col items-center">
      <Box className=" flex flex-col md:flex-row justify-start items-start w-11/12 mb-4">
        <Typography variant="h5" className="">
          {product.name}
        </Typography>
        <Typography
          variant="body1"
          className={
            product.digitalFocus
              ? " bg-red-100 py-2 px-3 text-red-500 "
              : "hidden"
          }
          sx={{
            borderRadius: "6px",
            marginLeft: { md: "15px" },
          }}
        >
          {product.digitalFocus}
        </Typography>
      </Box>
      <Grid className="w-11/12" container spacing={2}>
        <Grid size={{ xs: 12, md: 7 }} className="pr-4 relative">
          <ProductDetailImage productsImages={product.productImage ?? []} />
          <Box
            className={
              leftItems.length > 0
                ? "grid grid-cols-1 md:grid-cols-2 gap-x-8 bg-white rounded-xl p-5 mt-5 shadow-md"
                : "hidden"
            }
          >
            <Box>
              {(Array.isArray(leftItems) ? leftItems : []).map((text, idx) => {
                return renderShortDetail(text, idx);
              })}
            </Box>
            <Box>
              {(Array.isArray(rightItems) ? rightItems : []).map(
                (text, idx) => {
                  return renderShortDetail(text, idx);
                },
              )}
            </Box>
          </Box>
          <ProductSpecs
            specs={product.productDetail}
            htmlContent={htmlContent}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 5 }} className="relative">
          <div className="bg-white rounded-2xl p-3 shadow-md">
            <img src="/images/voucher.png" alt="voucher" className="pb-5" />
            <Price
              regularPrice={product.regularPrice ?? 0}
              salePrice={product.priceSale ?? 0}
              regularDiscount={product.regularDiscount ?? 0}
            />
            <HpList listHP={filteredHpData} />

            <Divider sx={{ my: 2 }} />
            <Box className="booking-button flex items-center justify-center">
              <button
                className="bg-orange-500 text-white px-4 py-4 font-bold shadow-md rounded-md w-3/4 hover:bg-orange-500/90 transition hover:shadow-lg"
                onClick={handleOpenBooking}
              >
                ĐẶT HÀNG NGAY
              </button>
            </Box>
            <Divider sx={{ my: 2 }} />
            <AdditionalInfo />
          </div>
          <SimilarProducts product={product} />
        </Grid>
      </Grid>
      <ScrollToTopButton />
      {/* Booking Modal */}
      <BookingModal
        open={openBooking}
        handleClose={handleCloseBooking}
        serviceName=""
      />
    </Box>
  );
});

export default ProductDetail;
